import { render, staticRenderFns } from "./sidepanel-toggle.vue?vue&type=template&id=0d1132c9&"
import script from "./sidepanel-toggle.vue?vue&type=script&lang=js&"
export * from "./sidepanel-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports